import {ComponentStore} from '@ngrx/component-store';
import {Injectable} from '@angular/core';
import {ReportCardParametersFiltersState} from './report-table-row-parameters-filters';
import {Store} from '@ngrx/store';
import {AppState} from '../../../../../../shared/store/store';
import {Observable, switchMap, withLatestFrom} from 'rxjs';
import {AdRParamsDimensionFilters} from '../../../../../../shared/interfaces/ad-reports';
import {filter, tap} from 'rxjs/operators';
import {DimensionComponentObject, DimensionComponentObjects} from '../../../../../../shared/classes/dimension-component-object';
import {selectDimensionComponentObjects, selectDimensionsLoaded} from '../../../../../../shared/store/selectors';

@Injectable()
export class ReportTableRowParametersFiltersStore extends ComponentStore<ReportCardParametersFiltersState> {
  public readonly nbFilters$: Observable<number> = this.select((state: ReportCardParametersFiltersState): number => state.nbFilters);
  public readonly enable$: Observable<boolean> = this.select((state: ReportCardParametersFiltersState): boolean => state.enable);
  public readonly filters$: Observable<Array<{ dimension: DimensionComponentObject, values: string }>> = this.select((state: ReportCardParametersFiltersState): Array<{ dimension: DimensionComponentObject, values: string }> => state.filters);

  private readonly _dimensionsLoaded: Observable<boolean> = this._store.select(selectDimensionsLoaded);
  private readonly _dimensionComponentObjects: Observable<DimensionComponentObjects> = this._store.select(selectDimensionComponentObjects);

  private readonly _init: (filters: AdRParamsDimensionFilters) => void = this.effect((params$: Observable<AdRParamsDimensionFilters>): Observable<any> => params$.pipe(
    switchMap((filtersParam: AdRParamsDimensionFilters) => this._dimensionComponentObjects.pipe(
      withLatestFrom(this._dimensionsLoaded),
      filter(([_, loaded]: [DimensionComponentObjects, boolean]): boolean => loaded),
      tap(([dimensionComponentObjects, _]: [DimensionComponentObjects, boolean]): void => {
        const filters: Array<{ dimension: DimensionComponentObject, values: string }> = [];
        let nbFilters: number = 0;

        for (const slug in filtersParam) {
          const dimension: DimensionComponentObject = dimensionComponentObjects.find((dimension: DimensionComponentObject): boolean => dimension.payload.attributes.slug === slug);

          if (dimension) {
            filters.push({
              dimension: dimension,
              values: filtersParam[slug].join(', ')
            });
          }

          nbFilters += filtersParam[slug].length
        }

        this.patchState({
          nbFilters: nbFilters,
          enable: nbFilters !== 0,
          filters: filters
        });
      })
    ))
  ));

  constructor(
    private readonly _store: Store<AppState>
  ) {
    super({
      enable: false,
      nbFilters: 0,
      filters: []
    });
  }

  public init(filters: AdRParamsDimensionFilters): void {
    this._init(filters);
  }

}
